<sd-border-wrapper
  [title]="!!isOverview && 'checkout.steps.firstStep' | translate"
  [hasBorder]="!!isOverview"
  customClass="brand--h4"
  [titleLevel]="!!isMobile$ ? 4 : 3"
  data-testid="wrapper"
>
  @if (!!isOverview) {
    <p sd-additional-title class="is-body-s" data-testid="overview">
      {{ (totalProducts > 1
        ? "checkout.orders.articles"
        : "checkout.orders.article"
        ) | translate : { article: totalProducts }
      }}
    </p>
  }

  @if (promo) {
    <sd-html innerClass="c__shipping-promo is-caption is-wysiwyg {{ isActiveBrand ? 'is-active-brand' : '' }}" [html]="promo" tag="div" />
  }

  <ul class="c__product-list" sd-list-block data-testid="list">
    @for (product of productsList; track trackByProductCode($index, product)) {
      <li data-testid="item">
        <sd-product-customer
          [indexFollow]="product?.indexFollow !== undefined ? product?.indexFollow : true"
          [titleLevel]="titleLevel"
          [productInfo]="product"
          [isReadOnly]="isReadOnly"
          [hasNoActions]="isReadOnly"
          [quantityDisabled]="quantityDisabled"
          [isBundle]="!!product.bundle"
          (delete)="onDelete($event)"
          (favorite)="onFavorite($event)"
          (quantity)="onQuantityChange(product.code, $event)"
          (openRecommendedPriceModal)="onopenRecommendedPriceModal()"
          data-testid="product"
        />

        @if (product?.warrantyOffers?.length > 0 || product?.extendedWarrantyOffer) {
          <div class="c__warranty-offers" data-testid="warranty">
            @if (step !== checkoutStepsEnum.payments && !isReadOnly && product?.warrantyOffers?.length > 0) {
              <sd-title [isDescription]="true" customClass="brand--h5">
                {{'cart.extendedWarranty.title' | translate}}
              </sd-title>
              <sd-warranty-checkbox-group
                [warranties]="product.warrantyOffers"
                [verticalLayout]="true"
                [showMore]="'addToCart.extendedWarranty.show.details' | translate"
                [showLess]="'addToCart.extendedWarranty.hide.details' | translate"
                (warrantyClicked)="onClickWarranty($event)"
              />
            }
            @if ((step === checkoutStepsEnum.payments || step === checkoutStepsEnum.recap) && product?.extendedWarrantyOffer) {
              <sd-warranty-informations [data]="product.extendedWarrantyOffer" />
            }
          </div>
        }
      </li>
    }
  </ul>
  @if (atLeastOneLowStockProduct) {
    <div class="c__low-stock_info">
      <sd-icon name="icon-info" [size]="iconSizeEnum.xs" />
      <p class="is-caption">{{ 'cart.stock.lowStock.warning' | translate }}</p>
    </div>
  }
</sd-border-wrapper>
